import { z } from 'zod';
// Event names the client sends (for typing and reports). The server accepts any
// well-formed name, so a new event never needs a server deploy first.
export const TELEMETRY_EVENT_TYPES = [
    'game_created', 'game_joined', 'game_started', 'game_ended',
    'question_answered', 'question_timed_out', 'category_selected',
    'theme_selected', 'settings_changed', 'player_left',
    'daily_challenge_started', 'daily_challenge_completed',
    'solo_challenge_started', 'solo_challenge_completed', 'solo_challenge_gave_up',
    'reaction_sent', 'share_clicked', 'profile_viewed', 'leaderboard_viewed',
    'settings_opened', 'category_filter_changed',
    'rematch_started', 'feedback_clicked',
    'app_opened', 'install_prompt_shown', 'install_prompt_clicked', 'install_prompt_dismissed', 'app_installed',
    'reminder_prompt_shown', 'reminder_enabled', 'reminder_denied', 'reminder_dismissed', 'reminder_disabled',
    'reminder_sent', // written by the server when it sends a push
    'report_opened', 'question_reported',
    'duel_started', 'duel_finished', 'duel_challenge_shared', 'duel_challenge_opened', 'duel_inbox_viewed',
    'duel_push_sent', // written by the server when it tells someone about a duel
    'duel_promo_clicked', 'duel_taunt_sent',
    'profile_saved', 'play_clicked', 'onboarding_topic_picked', 'achievement_unlocked',
    'league_viewed', 'league_result_sent', // league_result_sent is written by the server
    'weekly_recap_sent', // written by the server
    'topic_request_opened', 'topic_requested', 'topic_voted', 'topic_launch_opened',
    'topic_launch_sent', // written by the server
    'level_up',
    'quest_completed', 'quests_all_done',
    'q_viewed', 'q_answered', 'q_clicked', 'q_chain_answered', 'q_finished', // written by the /q page a social post links to (id, source = the platform's link code)
    'restore_code_shown', 'restore_offered', 'restore_done', 'restore_failed', 'restore_declined',
];
export const TELEMETRY_MAX_BATCH = 100;
export const TELEMETRY_MAX_PAYLOAD_CHARS = 2_000;
export const TelemetryEventSchema = z.object({
    type: z.string().regex(/^[a-z][a-z0-9_]{0,39}$/),
    timestamp: z.number().int().nonnegative(),
    sessionId: z.string().max(64).optional(),
    playerId: z.string().max(64).optional(),
    roomCode: z.string().max(12).optional(),
    payload: z.record(z.string(), z.unknown())
        .refine(p => JSON.stringify(p).length <= TELEMETRY_MAX_PAYLOAD_CHARS, 'payload too large'),
});
// Events are validated one by one on the server, so a single bad event
// doesn't cost the rest of the batch.
export const TelemetryBatchSchema = z.object({
    events: z.array(z.unknown()).min(1).max(TELEMETRY_MAX_BATCH),
});
